import * as actions from '../actions/actionTypes';
import initialState from './initialState';

/**
 * This reducer handles the LOAD_SERVICES_SUCCESS action and sets client account data in the store
 * @param {Object} [state] The client account data currently in the store, or the initial state of client account data
 * @param {Object} action The action to be handled
 * @returns {Object} The client account data
 */
export default function services(state = initialState.services, action) {
  switch (action.type) {
    case actions.LOAD_SERVICES_SUCCESS:
      if (action.services.length === 1 && action.services[0] === 'None') {
        return [];
      }
      return action.services;
    case actions.UNLOAD_SERVICES:
    case actions.UNLOAD_PERIOD:
      return initialState.services;
    default:
      return state;
  }
}
